import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TopicModel, TopicRequest, SubjectModelWithTopics } from '@generativ/much-smarter-models';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { ErrorHandlerService } from '../../core/services/error-handler.service';

@Injectable({ providedIn: 'root' })
export class TopicService {

  topic: TopicModel;
  topics: TopicModel[] = [];

  private topicsURL = environment.msApiUrl + 'topics/';

  constructor(private http: HttpClient,
              private errorHandlerService: ErrorHandlerService) {
  }

  createTopic(topic: TopicRequest.Create): Observable<TopicModel> {
    return this.http.post<TopicModel>(this.topicsURL, topic).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  updateTopic(id: number, course: TopicRequest.Update): Observable<TopicModel> {
    return this.http.patch<TopicModel>(this.topicsURL + id, course).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getTopic(id: number): Observable<TopicModel> {
    return this.http.get<TopicModel>(this.topicsURL + id).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getTopics(): Observable<TopicModel[]> {
    return this.http.get<TopicModel[]>(this.topicsURL).pipe(
      catchError(this.errorHandlerService.handleError));
  }

  getTopicsGroupBySubject(): Observable<SubjectModelWithTopics[]> {
    return this.http.get<SubjectModelWithTopics[]>(this.topicsURL + '?by=subject').pipe(
      catchError(this.errorHandlerService.handleError));
  }
}
